<template>
  <div v-if="areEqual && spellingPeriod">
    <strong>Period:</strong>
    {{ $filters.longDateFormat(spellingPeriod.start, false) }} to
    {{ $filters.longDateFormat(spellingPeriod.end, false) }}
  </div>
  <div v-else>
    <div v-if="spellingPeriod">
      <strong>Spellng Period:</strong>
      {{ $filters.longDateFormat(spellingPeriod.start, false) }} to
      {{ $filters.longDateFormat(spellingPeriod.end, false) }}
    </div>
    <div v-if="mathsPeriod && mathsAvailable">
      <strong>Maths Period:</strong>
      {{ $filters.longDateFormat(mathsPeriod.start, false) }} to
      {{ $filters.longDateFormat(mathsPeriod.end, false) }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { SfCostPeriod } from "@/types/generalTypes";
import { isMathsAvailable } from "@/state/appState";

export default defineComponent({
  props: {
    spellingPeriod: {
      type: Object as PropType<SfCostPeriod | null>,
      required: true,
    },
    mathsPeriod: {
      type: Object as PropType<SfCostPeriod | null>,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    mathsAvailable() {
      return isMathsAvailable('school', 'store');
    },
    areEqual() {
      return (
        this.spellingPeriod?.start == this.mathsPeriod?.start &&
        this.spellingPeriod?.end == this.mathsPeriod?.end
      );
    },
  },
});
</script>
